import React, { Component } from 'react';
import PubSub from 'pubsub-js';

import TOOLS from './TOOLS';

import Header from './Header';
import Footer from './Footer';
import AppPageStores from './AppPageStores';
import AdSenseArticle from './AdSenseArticle';
import AdSenseAntigo from './AdSenseAntigo';

//style
import '../css/AppPage.css';

class AppPage extends Component {  
  constructor() {
    super();
    this.serveUrl = "https://appstore.escolhatecnologia.com.br/api/";
    this.appFullContent= {};

    this.state = {
      app: null,
      lang : 'pt',
      serverResponse : false
    };

    this.locationTexts= {
      "carregando" : {"pt" : "Carregando...", "es": "Largando...", "en": "Loading..."},
      "capturas-de-tela" : {"pt" : "Capturas de Tela", "es" : "Capturas de Pantalla", "en" : "Screenshots"},
      "baixar-app" : {"pt" : "Baixar o App", "es" : "Descargar Aplicacion", "en" : "Download App"}
    }
  }
  
  getContentOfLang(lang){
    let content= this.appFullContent.Contents.filter( content => {return (content.lang === lang)});
    this.setState({app: content[0], lang});
    this.props.history.push(`/app/${lang}/${this.state.app.locationId}`);
  }

  getApps() {
    fetch(`${TOOLS.siteURL}/api/app/?appLocatedId=${this.props.match.params.appId}&lang=${this.state.lang}`)
      .then(response => response.json())
      .then(json => {
        if(json.ok){
            this.appFullContent= json.app;
            this.setState({app: json.app.selectedContent, serverResponse: true});
        }else{
          window.alert(json.message);
        }
        
      });   
  }

  componentWillMount() {
    window.scrollTo(0, 0);

    PubSub.subscribe('language.change', (msg, lang) => {
      this.getContentOfLang(lang);      
    });

    let getLang = new Promise((resolve, reject) => {
      let lang = "en";
      if (this.props.match.params.lang) {
        lang = this.props.match.params.lang;
      } else {
        let navLang = navigator.language.toLowerCase();
        let vetLangs = ["pt", "en", "es"];

        for (let i = 0; i < vetLangs.length; i++) {
          if (navLang.search(vetLangs[i]) !== -1) {
            lang = vetLangs[i];
            break;
          }
        }

      }
      resolve(lang);
    });
    getLang.then(lang => {
      //PubSub.publish("language.change", lang);
      this.setState({ lang });
      this.getApps();
    });
  }
  
  render() {
    const texts= this.locationTexts; 
    
    if(this.state.serverResponse){
      const app = this.state.app;
      return (
        <div>
          <Header />
          {/*Pagina do App {this.props.match.params.lang} {this.props.match.params.appId}*/}
          <section id="app-main-container">
            
            <AdSenseAntigo />
            <picture>
              <source media="(max-width: 600px)" srcSet={app.squareBanner} />
              <img src={app.wideBanner} alt="App" />
            </picture>
            <div className="app-main-title">{app.name}</div>
            
            <p id="app-main-description">
              {app.description}
            </p>
            
            <AdSenseArticle />

            <div className="app-main-title">{texts["baixar-app"][this.state.lang]}</div>

            <div id="app-main-downloadButtons">
              {app.Stores.map(store => <AppPageStores key={store.id} id={store.id} url={store.url} />)}
            </div>
  
            <div className="app-main-title">{texts["capturas-de-tela"][this.state.lang]}</div>
  
            <div id="app-main-prints">
              {app.prints.map(print => <img src={print} key={print} alt="Print" />)}
            </div>            
  
          </section>
          <Footer />
        </div>
      );
    }else{
      return(
        <div id="appPage-divPai">
          <Header />
          <section id="app-main-container">
            <div className="app-main-title">{texts["carregando"][this.state.lang]}</div>
          </section>
          <Footer />
        </div>
      );
    }
    
    
  }
}

export default AppPage;



// WEBPACK FOOTER //
// ./src/componentes/AppPage.js